<template>
    <seccion-datos titulo="APP" class="card card-warning" @cambios="guardar()" :botonGuardar="permisomodif">
        <div>
            <div class="row">
                <div class="col-md-6">
                    <div class="custom-control custom-checkbox">
                        <input :disabled="!permisomodif" type="checkbox" id="appmovil" class="custom-control-input" v-model="usa_app_movil_operario" v-bind:true-value="1" v-bind:false-value="0">
                        <label for="appmovil" class="custom-control-label">{{ $t('general.utilizaappmovil') }}</label>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="custom-control custom-checkbox">
                        <input :disabled="!permisomodif" type="checkbox" id="baremoapp" class="custom-control-input" v-model="ocultar_baremo_app" v-bind:true-value="1" v-bind:false-value="0"> 
                        <label for="baremoapp" class="custom-control-label">{{ $t('general.ocultarbaremoapp') }}</label>
                    </div>   
                </div>
                <div class="col-md-6">
                    <div class="custom-control custom-checkbox">
                        <input :disabled="!permisomodif" type="checkbox" id="baremoprecio" class="custom-control-input" v-model="ocultar_precio_baremo_app_operario" v-bind:true-value="1" v-bind:false-value="0">
                        <label for="baremoprecio" class="custom-control-label" >{{ $t('general.ocultarpreciobaremo') }}</label>
                    </div>
                </div>
                <div class="col-md-6" v-if="fichajes">
                    <div class="custom-control custom-checkbox">
                        <input :disabled="!permisomodif" type="checkbox" id="fichaje" class="custom-control-input" v-model="fichaje_operario" v-bind:true-value="1" v-bind:false-value="0">
                        <label for="fichaje" class="custom-control-label">{{ $t('general.fichaje') }}</label>
                    </div>
                </div>
                <div class="col-md-6" v-if="rga">
                    <div class="custom-control custom-checkbox">
                        <input :disabled="!permisomodif" class="custom-control-input" type="checkbox" id="pas" v-model="plataforma_pas" v-bind:true-value="1" v-bind:false-value="0">
                        <label for="pas" class="custom-control-label">{{ $t('general.plataformapasrga') }}</label>
                    </div>
                </div>
                <div class="col-md-6 pb-3">
                    <div class="custom-control custom-checkbox">
                        <input :disabled="!permisomodif" type="checkbox" id="app_pwgs" class="custom-control-input" v-model="app_pwgs" v-bind:true-value="1" v-bind:false-value="0">
                        <label for="app_pwgs" class="custom-control-label">{{ $t('general.apppwgs') }}</label>
                    </div>
                </div>
                <div class="col-md-12" v-if="distancia_maxima_estoy_en_domicilio_app">
                    <div class="custom-control custom-checkbox">
                        <input :disabled="!permisomodif" class="custom-control-input" type="checkbox" id="distancia_mas" v-model="habilitar_gps_estoy_en_domicilio" v-bind:true-value="1" v-bind:false-value="0">
                        <label for="distancia_mas" class="custom-control-label"><small>Deshabilitar bot&oacute;n "Estoy en domicilio" si est&aacute; a m&aacute;s de {{distancia_maxima_estoy_en_domicilio_app}} Km</small></label>
                    </div>
                </div>
                <div class="col-md-12" v-if="distancia_maxima_estoy_en_domicilio_app">
                    <div class="custom-control custom-checkbox">
                        <input :disabled="!permisomodif" class="custom-control-input" type="checkbox" id="distancia_menos" v-model="habilitar_gps_finalizar_visita_app" v-bind:true-value="1" v-bind:false-value="0">
                        <label for="distancia_menos" class="custom-control-label"><small>Deshabilitar bot&oacute;n "Finalizar" si est&aacute; a m&aacute;s de {{distancia_maxima_estoy_en_domicilio_app}} Km</small></label>
                    </div>
                </div>
            </div>
            <div>&nbsp;</div>
            <div class="d-flex justify-content-center">
            <button type="button" class="btn btn-primary " @click="enviarInfo()">{{ $t('general.enviaremailconfiguracionapp') }}</button>
            </div>
        </div>
    </seccion-datos>
</template>
<script>
import { PwgsApi } from '../../../../services/PwgsApi';
export default {
    props: ['id', 'operario', 'permisomodif'],
    data() {
        return {
            usa_app_movil_operario: '',
            ocultar_baremo_app: '',
            ocultar_precio_baremo_app_operario: '',
            fichaje_operario: '',
            plataforma_pas: '',
            app_pwgs: '',
            rga:false,
            fichajes:false,
            distancia_maxima_estoy_en_domicilio_app:'',
            habilitar_gps_estoy_en_domicilio:false,
            habilitar_gps_finalizar_visita_app:false
        }
    },
    methods: {
        cargarDatosOperario() {
            this.$store.dispatch('cambiarCargando', true);
            this.usa_app_movil_operario = this.operario.usa_app_movil_operario;
            this.ocultar_baremo_app = this.operario.ocultar_baremo_app;
            this.ocultar_precio_baremo_app_operario = this.operario.ocultar_precio_baremo_app_operario;
            this.fichaje_operario = this.operario.fichaje_operario;
            this.plataforma_pas = this.operario.plataforma_pas;
            this.app_pwgs = this.operario.app_pwgs;
            this.habilitar_gps_estoy_en_domicilio = this.operario.habilitar_gps_estoy_en_domicilio;
            this.habilitar_gps_finalizar_visita_app = this.operario.habilitar_gps_finalizar_visita_app;
            this.plataforma_pas = this.operario.plataforma_pas;
            this.$store.dispatch('cambiarCargando', false);
        },
        async guardar() {
            /* put  modulos/pwgsapi/index.php/operarios/:id */
            try {
                const api = new PwgsApi;
                const subidadatos = { usa_app_movil_operario: this.usa_app_movil_operario, ocultar_baremo_app: this.ocultar_baremo_app, ocultar_precio_baremo_app_operario: this.ocultar_precio_baremo_app_operario, fichaje_operario: this.fichaje_operario, plataforma_pas: this.plataforma_pas, app_pwgs: this.app_pwgs };
                this.$store.dispatch('cambiarGuardando', true);
                await api.put('operarios/' + this.operario.id, subidadatos);
                this.$store.dispatch('cambiarGuardando', false);
                this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Datos guardados correctamente', life: 2000 });
            }
            catch (error) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
            }
        },
        async enviarInfo() { 
            /* put  modulos/pwgsapi/index.php/operarios/:id/enviar-configuracion-app */
            try {
                const api = new PwgsApi;
                const subidadatos = { usa_app_movil_operario: this.usa_app_movil_operario, ocultar_baremo_app: this.ocultar_baremo_app, ocultar_precio_baremo_app_operario: this.ocultar_precio_baremo_app_operario, fichaje_operario: this.fichaje_operario, plataforma_pas: this.plataforma_pas, app_pwgs: this.app_pwgs };
                await api.put('operarios/' + this.id + '/enviar-configuracion-app', subidadatos);
                this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Enviado email de configuración', life: 2000 });
            }
              catch (error) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
            }
        },
        async comprobarParametros(){
            const api = new PwgsApi();
            var aux = await api.get('parametros-pwgs/rga');
            if (aux.rga == 1) {
                this.rga = true;
            }
            aux = await api.get('parametros-pwgs/fichajes');
            if (aux.fichajes == 1) {
                this.fichajes = true;
            }
            aux = await api.get('parametros-pwgs/distancia_maxima_estoy_en_domicilio_app');
            if (aux.distancia_maxima_estoy_en_domicilio_app > 0) {
                this.distancia_maxima_estoy_en_domicilio_app = aux.distancia_maxima_estoy_en_domicilio_app;
            }
        },
    },
    mounted() {
        this.cargarDatosOperario();
        this.comprobarParametros();
    },
    watch: {
        operario() {
            this.cargarDatosOperario();
        }
    },
}
</script>
<style>
.navbar-default .navbar-nav>.open>a,
.navbar-default .navbar-nav>.open>a:focus,
.navbar-default .navbar-nav>.open>a:hover {
    color: #555;
    background-color: #e7e7e7;
}
</style> 